// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success {
  background-color: rgb(115 128 255 / 10%);
  padding: 50px;
}
.book_btns {
  display: flex;
  justify-content: space-around;
}
section.book_exp {
  padding: 50px;
}
.why_choose_us .card_uni {
  border: 2px solid #c3c5f8;
  margin: 0px 20px;
  /* padding: 0px 45px; */
  display: flex;
  align-items: center;
  flex-direction: column;
}
.why_choose_us .card_uni_img {
  display: flex;
  align-items: center;
  margin-top: -100px;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: #f3f3fe;
}
section.testimonials {
  padding: 50px 0px;
  background: rgb(254 188 8 / 10%);
}

.landing_card1 span:first-child {
  font-size: 200px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 700;
}
.landing_card1 h2 {
  position: absolute;
  top: 50px;
  right: 100px;
}
.landing_card1 img {
  position: absolute;
  bottom: 0px;
}
.why_choose_us .inh2 {
  margin-bottom: 150px;
}
.success-card .text-container {
  background: rgb(115 128 255 / 10%);
}
.landing_card1 .item {
  overflow: hidden;
}
.landing_card1 .item:last-child {
  overflow: visible;
}
.landing_card1 .item:first-child img {
  position: absolute;
  bottom: -5px;
  left: 0px;
}
.landing_card1 .item:nth-child(3) img {
  bottom: -10px;
}
.landing_card1 .item:last-child img {
  position: absolute;
  bottom: -50px;
  right: -60px;
}
`, "",{"version":3,"sources":["webpack://./src/landingPage/landing1/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd","sourcesContent":[".success {\n  background-color: rgb(115 128 255 / 10%);\n  padding: 50px;\n}\n.book_btns {\n  display: flex;\n  justify-content: space-around;\n}\nsection.book_exp {\n  padding: 50px;\n}\n.why_choose_us .card_uni {\n  border: 2px solid #c3c5f8;\n  margin: 0px 20px;\n  /* padding: 0px 45px; */\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n.why_choose_us .card_uni_img {\n  display: flex;\n  align-items: center;\n  margin-top: -100px;\n  justify-content: center;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: #f3f3fe;\n}\nsection.testimonials {\n  padding: 50px 0px;\n  background: rgb(254 188 8 / 10%);\n}\n\n.landing_card1 span:first-child {\n  font-size: 200px;\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 700;\n}\n.landing_card1 h2 {\n  position: absolute;\n  top: 50px;\n  right: 100px;\n}\n.landing_card1 img {\n  position: absolute;\n  bottom: 0px;\n}\n.why_choose_us .inh2 {\n  margin-bottom: 150px;\n}\n.success-card .text-container {\n  background: rgb(115 128 255 / 10%);\n}\n.landing_card1 .item {\n  overflow: hidden;\n}\n.landing_card1 .item:last-child {\n  overflow: visible;\n}\n.landing_card1 .item:first-child img {\n  position: absolute;\n  bottom: -5px;\n  left: 0px;\n}\n.landing_card1 .item:nth-child(3) img {\n  bottom: -10px;\n}\n.landing_card1 .item:last-child img {\n  position: absolute;\n  bottom: -50px;\n  right: -60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
